export default function formatToAPIDate(date: Date) {
  return date.toISOString();
}
